import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-view container pb-5" }
const _hoisted_2 = { class: "card p-2 d-flex flex-row flex-wrap" }
const _hoisted_3 = { class: "ms-2" }
const _hoisted_4 = { class: "d-flex justify-content-end my-4 row p-2" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_DynamicForms = _resolveComponent("DynamicForms")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_ModalValidationBirdSpro = _resolveComponent("ModalValidationBirdSpro")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumbs),
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "h-medium" }, "Informe seus dados", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, "Confira seus dados antes de criar sua senha de emissão", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fw-600 capiton" }, "Certificado Adquirido", -1)),
          _createTextVNode(": " + _toDisplayString(_ctx.getProduto.nome), 1)
        ])
      ]),
      (_openBlock(), _createBlock(_component_DynamicForms, {
        key: _ctx.dynamicCount,
        ref: "dynamicComponent",
        fields: _ctx.form.fields,
        onIsValid: _ctx.handleIsValid
      }, null, 8, ["fields", "onIsValid"])),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["col-sm-12 col-md-2 btn btn-primary", !_ctx.isValid ? 'btn-secondary' : 'btn-primary']),
          type: "button",
          disabled: !_ctx.isValid,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.finishJourney && _ctx.finishJourney(...args)))
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "me-2" }, "Avançar", -1)),
          _createVNode(_component_Icon, { name: "arrow-right" })
        ], 10, _hoisted_5)
      ]),
      _createVNode(_component_Contact)
    ]),
    _createVNode(_component_ModalValidationBirdSpro, {
      ref: "modalValidationBirdSpro",
      hotreload: 
      () => {
        _ctx.dynamicCount++
      }
    
    }, null, 8, ["hotreload"])
  ], 64))
}